// This file is auto-generated from Ruby constants.
// Do not edit manually. Use rake export_ts_constants to regenerate.

export const COST_CATEGORIES = ["office_visit", "specialist_visit", "generic_drugs", "brand_drugs", "emergency_room_visit", "hospitalization", "lung_cancer"];

export const COST_CATEGORY_PROCEDURE_IDS = {
  office_visit: 1751,
  specialist_visit: 1802,
  generic_drugs: 1945,
  emergency_room_visit: 1636,
  brand_drugs: 1946,
  pregnancy: 1935,
  hospitalization: 1944,
  mri: 1727,
  broken_leg: 1566,
  lung_cancer: 1712,
};

export const SINGLE_TERM_COSTS = {
  ambulance: 1000,
  chiropractic: 90,
  emergency_room: 850,
  hospitalization: 8000,
  hospitalization_physician: 3000,
  labor_facility: 8000,
  labor: 3000,
  labs: 200,
  mental_health: 90,
  mri: 1500,
  pcp_visit: 90,
  physical_therapy: 150,
  prenatal_office_visit: 90,
  baby_care: 90,
  specialist_visit: 200,
  substance_abuse: 90,
  surgery: 10000,
  surgery_staff: 3000,
  urgent_care: 110,
  xray: 200,
};

export const DRUG_TIERS_DEFAULT_COST = {
  generic: 35,
  brand: 200,
  specialty: 800,
};

export const DRUG_TIER_KEY_PREFIX = "drug_tier:";

export const COST_COLLECTIONS = {
  chest_x_ray: [1578],
  mri_scan: [1727],
  pregnancy: [1935],
  broken_leg: [1566],
  car_accident: [1541, 1566, 1727, 1537],
  heart_attack: [1864],
  diabetes: [1617],
};
